import React, {useEffect, useState} from "react";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";
import $ from "jquery";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import CommonAttachments from "../../../common/attachment/Attachment";
import ShowPerformers from "./modals/showPerformers";

const Detail = () => {

  const [media, setMedia] = useState(null);
  const [performers, setPerformers] = useState([]);

  const handleModalPerformers = async () => {
    setPerformers([])

    let result = await omnimap.GetRelationAction(
        window.$catalog_work_resources_selectedRow.identification,
        1,
        30,
        window.$catalog_management_units_token
    );
    if(result.data){
      const a = result.data.filter((m) => m.role === "UITVOERDER_WERKBRON")
      await setPerformers(a);
    }

    $("#show-performers-list-modal").modal("show");
  };


  const handleModalAttachments = async () => {
    const spin = $("#cover-spin");
    spin.show(0);
    let result = await omnimap.GetMediaListAction(
        { path: "" },
        window.$catalog_work_resources_selectedRow.identification,
        window.$catalog_management_units_token
    );
    await setMedia(result);
    spin.hide(0);

    $("#wp-catalogus-attachments").modal("show");
  };

  return (
    <div id="detailSide" className="d-none">
      <div className="detail-title">Werkbron in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            Werkbronnen
          </a>
        </div>
        <div className="float-right mt-0">
          <a id="edit-button" className="button bewerken">
            Bewerken
          </a>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam werkplan</div>
            <div className="box-title-2-active" id="d-algemeen-naam" />
            <span className="tooltiptext detail" id="naam-tooltip" id="Naam werkplan-tooltip"></span>

          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Code</div>
            <div className="box-title-2" id="d-algemeen-code" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Omschrijving</div>
            <div className="box-title-2" id="d-algemeen-omschrijving" />
            <span className="tooltiptext detail" id="naam-tooltip" id="d-algemeen-omschrijving-tooltip"></span>

          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Kosteneenheid</div>
            <div className="box-title-2" id="d-algemeen-kosteneenheid" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Actief</div>
            <label className="switch">
              <input id="work_resources_active" type="checkbox" disabled />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Prijs</div>
            <div className="box-title-2" id="d-algemeen-prijs" />
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-sm-6">
          <div className="inp-labl">Datum aangemaakt</div>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <img src={dateTimePng} width={30} height={28} />
              </span>
            </div>
            <input
              type="text"
              className="form-control inp-h inpp"
              id="d-timestamp_created"
              disabled
              placeholder=""
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="inp-labl">Datum laatst gewijzigd</div>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <img src={dateTimePng} width={30} height={28} />
              </span>
            </div>
            <input
              type="text"
              className="form-control inp-h inpp"
              id="d-timestamp_any_update"
              disabled
              placeholder=""
            />
          </div>
        </div>
        <div className="col-lg-2 text-center">
          <div className="box-detail">
            <div className="box-title-1">Bijlage(n)</div>
            <a role="button" onClick={() => handleModalAttachments()}>
              <div className="box-title-2 bijlage-ico" id="d-bijlage" />
            </a>
          </div>
        </div>
        <div className="col-lg-2 text-center">
          <div className="box-detail">
            <div className="box-title-1">Uitvoeders</div>
            <a role="button" onClick={handleModalPerformers}>
              <div className="box-title-2 gebruikers-ico" id="d-performers" />
            </a>
          </div>
        </div>

      </div>
      <CommonAttachments
          media={media}
          setMedia={setMedia}
          rowId={window.$catalog_work_resources_selectedRow.identification}
          contextToReload={window.$catalog_work_resources_context}
      />
      <ShowPerformers performers={performers}/>
    </div>
  );
};

export default Detail;
